module.exports = __webpack_public_path__ + "static/media/510.1bacffb4.jpg";